import {matchesJobStatus} from "../service/jobScheduling";
import {replaceJobSnapshot} from "../service/jobSnapshot";
import { useCallback, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { assignJobSupervisor, getAllJobsString, toDateString } from "../service/JobService";
import { getDirectoryEntriesByRole, getUsers, mapDirectoryEntriesById } from "../service/UserService";
import ActiveWorkerToggleGroup from "./ActiveWorkerToggleGroup";
import JobCardList from "./JobCardList";
import JobStatusToggleGroup from "./JobStatusToggleGroup";
import SchedulerToolbar from "./scheduler/SchedulerToolbar";
import { buildFieldCounts, buildStatusCountsWithTask, enrichJobsWithSummaryCounts, isTaskJob, jobMatchesSearch, stringToDate } from "./scheduler/schedulerUtils";
import loadSummaryCountMap from './scheduler/loadSummaryCountMap';
import {createIssueSummaryTracker} from './propertyissue/propertyIssueSummary';


export default function JobSupervising() {
    const now = new Date();
    const [isLoading, setIsLoading] = useState(false)
    const latestTableData = useRef([]);
    const requestSequence = useRef(0);
    const [issueSummaryTracker] = useState(createIssueSummaryTracker);
    const [tableData, setTableData] = useState([])

    const [leftBorderHighlight, setLeftBorderHighlight] = useState(false)
    const [rightBorderHighlight, setRightBorderHighlight] = useState(false)

    const [fieldSupervisorMap, setFieldSupervisorMap] = useState({})
    const [fieldSupervisorArray, setfieldSupervisorArray] = useState([])
    const [fieldWorkerMap, setFieldWorkerMap] = useState({})
    const [filteredData, setFilteredData] = useState([])


    const [radioValue, setRadioValue] = useState(() => {
        const radioValue = localStorage.getItem('radioValue');
        return radioValue ? radioValue : "Pending";
    });

    const [statusCounts, setStatusCounts] = useState({})
    const [supervisorCounts, setSupervisorCounts] = useState({})

    const [selectedDate, setSelectedDate] = useState(() => {
        const schedulerDate = localStorage.getItem('schedulerDate');
        return schedulerDate ? schedulerDate : toDateString(now);
    });

    const [searchText, setSearchText] = useState(() => {
        const searchText = localStorage.getItem('searchText');
        return searchText ? searchText : "";
    });
    const scheduler1 = "3";
    const [activeSuperVisorId, setActiveSuperVisorId] = useState(scheduler1)

    function handleJobUpdated(updated) {
        filterTables(latestTableData.current.map(job => job.cos_job_id === updated.cos_job_id
            ? replaceJobSnapshot(job, updated) : job), radioValue, searchText);
    }

    const handleIssueSummaryChanged = useCallback((propertyId, summary) => {
        const revision = issueSummaryTracker.getRevision();
        issueSummaryTracker.record(propertyId, summary);
        latestTableData.current = issueSummaryTracker.apply(latestTableData.current, revision);
        setTableData(previous => issueSummaryTracker.apply(previous, revision));
        setFilteredData(previous => issueSummaryTracker.apply(previous, revision));
    }, [issueSummaryTracker]);

    async function refreshJobList(currentSelectionDate) {
        const sequence = ++requestSequence.current;
        const summaryRevision = issueSummaryTracker.getRevision();
        setIsLoading(true);
        try {
            const response = await getAllJobsString(currentSelectionDate, currentSelectionDate);
            if (response.status !== 200) {
                console.log(await response.text());
                return;
            }
            const result = await response.json();
            const summaries = await loadSummaryCountMap(result);
            if (sequence !== requestSequence.current) return;
            filterTables(issueSummaryTracker.apply(enrichJobsWithSummaryCounts(result, summaries), summaryRevision), radioValue, searchText);
        } catch (error) {
            console.log('error', error);
        } finally {
            if (sequence === requestSequence.current) setIsLoading(false);
        }
    }

    function refreshUserDirectory() {
        getUsers({roles: ['WORKER', 'SUPERVISOR']}).then(response => {
            if (response.status === 200) {
                response.json().then(payload => {
                    const workers = getDirectoryEntriesByRole(payload, 'WORKER');
                    const supervisors = getDirectoryEntriesByRole(payload, 'SUPERVISOR');
                    setFieldWorkerMap(mapDirectoryEntriesById(workers));
                    setfieldSupervisorArray(supervisors);
                    setFieldSupervisorMap(mapDirectoryEntriesById(supervisors));
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    useEffect(() => {
        console.log("useEffect Render in Scheduler")
        refreshUserDirectory();
        refreshJobList(selectedDate);
        return () => { requestSequence.current += 1; };
    }, []);

    function handleSelect(value) {
        setSelectedDate(value);
        localStorage.setItem('schedulerDate', value);
        refreshJobList(value);
    }

    function filterTables(rawdata, radioValue, searchText) {
        latestTableData.current = rawdata;
        let searchScopedData = rawdata
        if (searchText && searchText.length > 0) {
            searchScopedData = rawdata.filter(item => jobMatchesSearch(item, searchText, fieldWorkerMap, fieldSupervisorMap));
        }

        setStatusCounts(buildStatusCountsWithTask(searchScopedData));

        let tempData = searchScopedData
        if (radioValue === '__TASK__') {
            tempData = searchScopedData.filter((item) => isTaskJob(item));
        } else if (radioValue !== 'ALL') {
            tempData = searchScopedData.filter(item => matchesJobStatus(item, radioValue),);
        }

        setSupervisorCounts(buildFieldCounts(tempData, "cos_job_supervisor"));
        setTableData(rawdata)
        setFilteredData(tempData)
    }


    function toggleRoleFilter(value) {
        setRadioValue(value)
        localStorage.setItem('radioValue', value);
        filterTables(tableData, value, searchText)
    }

    function filterSearchText(value) {
        setSearchText(value)
        localStorage.setItem('searchText', value);
        // setRoleFilterSelection
        filterTables(tableData, radioValue, value)

    }

    function delta(x) {
        let d = new Date()
        if (x !== 0) {
            d = stringToDate(selectedDate)
            d.setDate(d.getDate() + x);
        }
        setSelectedDate(toDateString(d))
        localStorage.setItem('schedulerDate', toDateString(d));
        refreshJobList(toDateString(d))

    }


    function handleDrop(ev, supervisorId) {
        ev.preventDefault();
        let data = ev.dataTransfer.getData('cos_job_id');
        assignJobSupervisor(data, supervisorId).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    refreshJobList(selectedDate);
                })
            } else {
                response.text().then(result => {
                        // setResponseMessage(result);
                        refreshJobList(selectedDate);
                    }
                )

            }
        }).catch(error => console.log('error', error));
    }

    function handleAssignDrop(ev) {
        setIsLoading(true)
        handleDrop(ev, activeSuperVisorId)
        setRightBorderHighlight(false)
        setLeftBorderHighlight(false)
    }

    function handleRevertDrop(ev) {
        //Hard code back to 3 as //Pending Status
        setIsLoading(true)
        handleDrop(ev, 3)
        setRightBorderHighlight(false)
        setLeftBorderHighlight(false)
    }

    function getSupervisorFilter() {
        return filteredData.filter(job => job.cos_job_supervisor === (activeSuperVisorId + "") && job.status !== "Cancelled");
    }

    return (<Container fluid>
            <SchedulerToolbar
                isLoading={isLoading}
                selectedDate={selectedDate}
                searchText={searchText}
                onDateOffset={delta}
                onDateSelect={handleSelect}
                onRefresh={() => refreshJobList(selectedDate)}
                onSearchTextChange={filterSearchText}
                statusControls={(
                    <JobStatusToggleGroup
                        radioValue={radioValue}
                        setRadioValue={toggleRoleFilter}
                        statusCounts={statusCounts}
                    />
                )}
            />
            <hr/>
            <Row>
                <Col onDragOver={(e) => {
                    e.preventDefault()
                    setLeftBorderHighlight(true)
                    setRightBorderHighlight(false)
                }}
                     onDrop={handleRevertDrop}
                     style={{
                         height: Math.max(tableData.length, getSupervisorFilter().length) * 420,
                         border: leftBorderHighlight ? '3px dashed darkBlue' : '3px dashed transparent'

                     }}
                >

                    {filteredData.length > 0 ? filteredData.map((job, idx) => (<JobCardList
                        job={job}
                        key={idx}
                        fieldWorkerMap={fieldWorkerMap}
                        fieldSupervisorMap={fieldSupervisorMap}
                        onJobUpdated={handleJobUpdated}
                        onIssueSummaryChanged={handleIssueSummaryChanged}
                        isLoading={isLoading}

                    />)) : <div style={{
                        height: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                            <span>No Job available on Current Date and Filter <br/>
                            <a href="#" onClick={() => {
                                filterSearchText("")
                            }}>Try Clear Filter</a></span>
                    </div>}
                </Col>
                <Col onDragOver={(e) => {
                    e.preventDefault()
                    setRightBorderHighlight(true)
                    setLeftBorderHighlight(false)
                }}
                     onDrop={handleAssignDrop}
                     style={{
                         height: Math.max(tableData.length, getSupervisorFilter().length) * 420,
                         border: rightBorderHighlight ? '3px dashed darkBlue' : '3px dashed transparent'
                     }}
                >
                    <Row><Col sm={12}><ActiveWorkerToggleGroup
                        activeWorkerId={activeSuperVisorId}
                        setActiveWorkerId={setActiveSuperVisorId}
                        workerStatusCount={supervisorCounts}
                        fieldWorkerMap={fieldSupervisorMap}
                        fieldWorkerArray={fieldSupervisorArray}/></Col></Row>
                    {getSupervisorFilter()
                        .map((job, idx) => (<JobCardList
                            job={job}
                            key={idx}
                            onJobUpdated={handleJobUpdated}
                            onIssueSummaryChanged={handleIssueSummaryChanged}
                            fieldSupervisorMap={fieldSupervisorMap}
                            fieldWorkerMap={fieldWorkerMap}/>))}

                </Col>

            </Row>


        </Container>


    );
}
